module.exports = __webpack_public_path__ + "img/header-weddingRingsPlatinum@2x.3c1f920.jpg";